import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import logo from "../../logo.png";
import loginlogo from "../../loginlogo.jpeg";
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Store/LoginStore/LoginSlice";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router-dom";
import { openSideBarModal } from "../../Store/Common/commonStore";

const AppBar = styled(
  MuiAppBar,
  {}
)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAccountClick = () => {
    navigate("profile/edit");
    setAnchorEl(null);
  };
  const handleLogoutClick = () => {
    window.location.href = "https://ssp.moreconnect.in/loginv2";
    dispatch(logout());
    setAnchorEl(null);
  };
  const [id, setId] = useState(localStorage.getItem("user_id") || "");
  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    setId(userId);
  }, []);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const openSideBar = useSelector((state) => state.common?.openSideBar);

  const checkForPlanoRoutes = () => {
    if (
      location.pathname === "/plano_portal/store" ||
      location.pathname === "/plano_portal/gallery" ||
      location.pathname === "/plano_portal/plano"
    ) {
      return true;
    }
    return false;
  };
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" color="inherit" style={{ height: 58 }}>
          <Toolbar style={{ height: 50, paddingBottom: 10 }}>
            <img
              src={logo}
              alt="Logo"
              onClick={() => navigate("/")}
              style={{ width: "120px", height: "auto", marginLeft: "-10px" }}
            />
            {checkForPlanoRoutes() && isSmallScreen && (
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, marginLeft: 2 }}
                onClick={() => dispatch(openSideBarModal(!openSideBar))}
              >
                <MenuIcon style={{ fontSize: "large", color: "silver" }} />
              </IconButton>
            )}
            <div style={{ flexGrow: 1 }} />
            <Stack direction={"row"} spacing={1}>
              <Button
                style={{
                  marginRight: -20,
                  textTransform: "none",
                  color: "#8f9398",
                  fontWeight: "bold",
                  fontFamily: `"Metropolis", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
                }}
                onClick={() =>
                  window.open(
                    "https://moreretail.bit.ai/docs/view/eTNQHFKYbDaaMEWA"
                  )
                }
              >
                User Guide
              </Button>
              <Button
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <Avatar alt="Login" src={loginlogo} sx={{marginRight:-5}}/>
              </Button>
            </Stack>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <MenuItem onClick={handleClose}>
                <Avatar alt="Login" src={loginlogo} />
                <Stack>
                  <Typography margin={1}> {id} </Typography>
                  {/* <Typography>User Email</Typography> */}
                </Stack>
              </MenuItem>
              <Divider />
              {/* <MenuItem onClick={handleAccountClick}>
                <SettingsIcon /> Account
              </MenuItem> */}
              <MenuItem onClick={handleLogoutClick}>
                <LogoutIcon />
                Logout
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default Navbar;
